import Video from '../modules/video';
export default class VideoModal {

  constructor(root) {
    this.container = root;
    this.Video = new Video(this.container.querySelector('.video-container'))
    this.sibling = this.container.previousSibling.previousSibling;

    this.watchButton = this.sibling.querySelector('.video-modal__button');
    this.closeButton = this.container.querySelector('.video-modal__close-button');


    if(this.watchButton) {
      this.watchButton.addEventListener('click', () => this.handleOpenClick(this.container));
    }
    this.closeButton.addEventListener('click', () => this.hanleCloseClick(this.Video, this.container));

    // Close popup on Escape key.
    document.addEventListener('keydown', () => {if (event.keyCode === 27) { this.hanleCloseClick(this.Video, this.container) }});
  }

  handleOpenClick(modal) {
    const body = document.querySelector('body');
    body.classList.add('modal--open');
    modal.classList.add('video-modal--open');

    const scrollY = '-' + window.scrollY + 'px';
    body.style.position = 'fixed';
    body.style.top = scrollY;

    this.onOpen();
  }
  hanleCloseClick(VideoInstance, modal) {
    const body = document.querySelector('body');
    body.classList.remove('modal--open');
    modal.classList.remove('video-modal--open');

    if(VideoInstance.source === 'youtube') {
      VideoInstance.player.pauseVideo();
    } else {
      VideoInstance.player.pause();
    }

    const scrollY = body.style.top;
    body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);

    this.onClose();
  }

  /**
   * A callback to be invoked when the modal opens. Override
   * this method on your instance if you need it
   */
  onOpen() {

  }

  /**
   * A callback to be invoked when the modal closes. Override
   * this method on your instance if you need it
   */
  onClose() {

  }

}